import { gsap } from "gsap";
import { SplitText } from "../../plugins/gsap/SplitText";

gsap.registerPlugin(SplitText);

import { debounce } from "../../utils";

class SplitTextAnimation  {

    static instance = null;
    static create(options) {
        if (SplitTextAnimation.instance === null) {
            SplitTextAnimation.instance = new SplitTextAnimation(options);
        }
        return SplitTextAnimation.instance;
    }

    static get defaultOptions() {
        return {
            selector: null,
            delay: 0,
        };
    }

    constructor(options) {
        this.options = Object.assign({}, SplitTextAnimation.defaultOptions, options)
        this.elements = document.querySelectorAll(this.options.selector);
        this.setup();
        this.initAnimation();
        this.typewriterAnimtion();
        this.events();
    }

    setup() {
        this.splitText = [];

        if(this.elements.length) {
            this.elements.forEach((element, index) => {
                const splitText = new SplitText(element, {type: "lines"});
                this.splitText.push(splitText);
            });
        }
    }

    revert() {
        this.splitText.forEach((element, index) => {
            element.revert();
        });
        this.setup();
    }

    initAnimation() {
        const elements = document.querySelectorAll('[data-split-text], [data-typewriter]');
        const elementsDiv = document.querySelectorAll('[data-split-text] div');

        if(elements.length) {
            gsap.set(elements, {opacity: 1});
        }

        if(elementsDiv.length) {
            gsap.set(elementsDiv, {z:-400,force3D: true,transformStyle: "preserve-3d", transformOrigin: "center bottom", y: 50, rotationX: "-90deg"})
            gsap.timeline({delay:this.options.delay})
                .to(elementsDiv, {duration: 1,y:0,z:0,rotationX:'0deg',force3D: true,stagger: { each:0.1 }, ease: "expo.out"})
        }
    }

    typewriterAnimtion() {
        this.elementTypewriter = [...document.querySelectorAll('[data-typewriter]')];

        if(this.elementTypewriter.length) {
            this.elementTypewriter.forEach((element, index) => {
                this.splitTextChar = new SplitText(element, {type: "chars", reduceWhiteSpace: false});
                this.chars = this.splitTextChar.chars;

                gsap.from(this.chars, {display: 'none', duration: 1, stagger: 0.05, delay: 1, ease: "expo.out"})
            });
        }
    }

    events() {
        window.addEventListener('resize', debounce(this.onResize.bind(this), 250));
    }

    onResize() {
        this.revert();
    }

}

export default SplitTextAnimation;
